<div
	class="flex w-[370px] flex-col gap-2 p-6"
	(click)="$event.stopPropagation()"
>
	<div class="flex flex-col gap-4 rounded-lg border border-solid border-outline p-4">
		<div
			class="flex items-center"
			[class.cursor-wait]="$loading()"
		>
			@if ($loading()) {
				<div class="flex p-2">
					<div class="h-10 w-10 animate-pulse rounded-lg bg-background-alt"></div>
				</div>
				<div class="flex flex-1 flex-col overflow-hidden p-2">
					<div class="my-[3px] h-3.5 w-full animate-pulse rounded-lg bg-background-alt"></div>
					<div class="my-[3px] h-3.5 w-full animate-pulse rounded-lg bg-background-alt"></div>
				</div>
			} @else {
				<div class="flex p-2">
					<cba-svg-centred-icon
						class="rounded-lg bg-background-input p-2"
						[name]="$fullClient() | fullClientIcon"
						[size]="24"
						color="fill-on-background-alt"
					/>
				</div>

				<div class="flex flex-1 flex-col overflow-hidden p-2">
					<span class="block truncate text-sm font-bold leading-5 text-on-background">
						{{ $fullClient() | fullClientName }}
					</span>

					<span class="line-clamp-2 overflow-hidden break-all text-sm leading-5 text-on-background">
						{{ $fullClient() | fullClientRole }}
					</span>
				</div>
			}
		</div>

		<div class="flex flex-col gap-2">
			@for (item of $menuItems(); track item.id) {
				@if (item["items"]; as items) {
					@if (items.length) {
						<cba-accordion
							[expanded]="$activeMenuId() === item.id"
							(expandedChange)="expanded($event, item.id)"
						>
							<ng-template
								#header
								let-expanded
							>
								<div class="flex flex-1 gap-2 overflow-hidden p-2">
									<uikit-icon
										class="items-center"
										[name]="item.icon"
										size="md"
										fill="on-background-alt"
									/>

									<div
										class="block select-none items-center gap-3 truncate font-body text-sm font-bold leading-5 text-on-background hover:cursor-pointer"
									>
										{{ item.label }}
									</div>

									<div class="flex flex-1 justify-end">
										<uikit-button
											size="small"
											radius="full"
											color="tonal"
											icon="angle-down"
											[submit]="false"
											[className]="
												'transition-transform duration-300 ' +
												(expanded ? 'rotate-180' : 'rotate-0')
											"
										/>
									</div>
								</div>
							</ng-template>

							<ng-template #content>
								<div class="mt-2 flex flex-col gap-2">
									@for (item of items; track item.id) {
										<button
											class="block truncate px-2 text-start font-body text-base font-normal leading-6 text-on-background-alt hover:cursor-pointer hover:underline"
											(click)="onAction(item)"
										>
											{{ item.label }}
										</button>
									}
								</div>
							</ng-template>
						</cba-accordion>
					}
				} @else {
					<button
						class="flex flex-1 gap-2 p-2"
						(click)="onAction(item)"
					>
						<uikit-icon
							class="items-center"
							[name]="item.icon"
							size="md"
							fill="on-background-alt"
						/>

						<div
							class="flex select-none items-center gap-3 font-body text-sm font-bold leading-5 text-on-background hover:cursor-pointer"
						>
							{{ item.label }}
						</div>
					</button>
				}

				@if (!$last) {
					<uikit-divider size="line" />
				}
			}
		</div>
	</div>

	<div class="flex flex-col items-end gap-2">
		<uikit-button
			class="w-full"
			color="link"
			size="small"
			iconRight="info-circle"
			(action)="redirectAbout()"
		>
			À propos
		</uikit-button>

		<uikit-button
			class="w-full"
			color="tonal"
			(action)="logout()"
		>
			Déconnexion
		</uikit-button>
	</div>
</div>
